import { useEffect, useRef } from 'react';

type Callback = () => void;

export default function useInterval(
	callback: Callback,
	interval?: number,
	deps?: any[]
): void {
	const cachedCallback = useRef<Callback>(null);

	// Lock polling at 50ms, anything below it (or `undefined`) disables the interval
	const intervalThreshold = 50;

	if (!deps) {
		deps = [];
	}

	useEffect(() => {
		cachedCallback.current = callback;
	}, [callback, ...deps]);

	useEffect(() => {
		function tick() {
			if (cachedCallback.current) {
				cachedCallback.current();
			}
		}

		if (
			interval === undefined ||
			Number.isNaN(interval) ||
			interval < intervalThreshold
		) {
			return;
		}

		const id = setInterval(tick, interval);

		return () => clearInterval(id);
	}, [interval]);
}
